import React from 'react';

const modalClasses = `
  shadow-2xl text-gray-800 bg-white
  dark:text-white dark:bg-gray-900
  border-1 rounded-2xl
  font-['Roboto']
  pointer-events-auto
  w-full
`;
const SwivuHomeLayout = ({ children, className }) => {
  return (
    <div className={`flex flex-col items-center ${modalClasses} p-5 max-h-[34rem] ${className}`}>
      {children}
    </div>
  );
};

export default SwivuHomeLayout;